export default ['Type1', 'Type2', 'ThirdPartyType1', 'ThirdPartyType2', 'Type2Outlet']
